import setting from './setting.js'
import http from "./http.js"
import ls from "./ls.js"
import queryString from "qs"

function qs(options) {
    return queryString.stringify(options, {arrayFormat: 'bracket'})
}

export default {
    ALERT: {
        // GET alerts/index
        getIndex (options, successCallback, errorCallback) {
            http('alerts?' + qs(options)).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
    },
    RANKING: {
        // GET ranking/index
        getIndex (options, successCallback, errorCallback) {
            http('rankings?' + qs(options)).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
    },
    /****************************************************
     * TEAMS
     ****************************************************/
    TEAMS: {
        // GET teams/ index
        getIndex (successCallback, errorCallback) {
            http('team/', {
                headers: {
                    'X-mode': 'detail'
                }
            }).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        /*
         * PLAYERS
         */
        PLAYERS: {
            // GET teams/players index
            getIndex (teamID, successCallback, errorCallback) {
                return http('teams/' + teamID + '/players/').then(({
                    json,
                    status,
                    headers
                }) => successCallback(json, status, headers)).catch(errorCallback)
            },
            // GET teams/players detail
            getDetail (teamID, playerID, successCallback, errorCallback) {
                http('teams/' + teamID + '/players/' + playerID).then(({
                    json,
                    status,
                    headers
                }) => successCallback(json, status, headers)).catch(errorCallback)
            },
            // PUT teams/players detail(admin)
            putDetail (teamID, playerID, option, successCallback, errorCallback) {
                http('teams/' + teamID + '/players/' + playerID, {}, 'PUT', JSON.stringify(option)).then(({
                    json,
                    status,
                    headers
                }) => successCallback(json, status, headers)).catch(errorCallback)
            },
            /*
            * PLAYERS/RISK & AVERAGE 20200204
            */
            RISKAVERAGE: {
                // GET teams/players/risk index
                getDetail (teamID, playerID, options, successCallback, errorCallback) {
                    http('teams/' + teamID + '/players/' + playerID + '/riskaverage?' + qs(options)).then(({
                        json,
                        status,
                        headers
                    }) => successCallback(json, status, headers)).catch(errorCallback)
                }
            },
            /*
            * PLAYERS/GAMES
            */
            GAMES: {
                // GET teams/players/games index
                getIndex (teamID, playerID, options, successCallback, errorCallback) {
                    http('teams/' + teamID + '/players/' + playerID + '/games?' + qs(options)).then(({
                        json,
                        status,
                        headers
                    }) => successCallback(json, status, headers)).catch(errorCallback)
                },
                getIndexQuery (teamID, playerID, query, successCallback, errorCallback) {
                    let options = {}
                    if ('team' in query) {
                        options['team'] = query.team
                    }
                    if ('dateAfter' in query) {
                        options['date-after'] = query.dateAfter
                    }
                    if ('dateBefore' in query) {
                        options['date-before'] = query.dateBefore
                    }
                    if ('timeAfter' in query) {
                        options['time-after'] = query.timeAfter
                    }
                    if ('timeBefore' in query) {
                        options['time-before'] = query.timeBefore
                    }
                    if ('level' in query) {
                        options['level'] = query.level
                    }
                    if ('league' in query) {
                        options['league'] = query.league
                    }

                    http('teams/' + teamID + '/players/' + playerID + '/games?' + qs(options)).then(({
                        json,
                        status,
                        headers
                    }) => successCallback(json, status, headers)).catch(errorCallback)
                },
                // GET teams/players/games detail
                getDetail (teamID, playerID, gameID, successCallback, errorCallback) {
                    return http('teams/' + teamID + '/players/' + playerID + '/games/' + gameID).then(({
                        json,
                        status,
                        headers
                    }) => successCallback(json, status, headers)).catch(errorCallback)
                },
                getDetailBiomechanic (teamID, playerID, gameID, successCallback, errorCallback) {
                    return http('teams/' + teamID + '/players/' + playerID + '/games/' + gameID + "?type=biomechanic").then(({
                        json,
                        status,
                        headers
                    }) => successCallback(json, status, headers)).catch(errorCallback)
                },
                /*
                * PLAYERS/GAMES/PITCHING
                */
                PITCHING: {
                    // GET teams/players/games/pitches index
                    getIndex (teamID, playerID, gameID, successCallback, errorCallback) {
                        http('teams/' + teamID + '/players/' + playerID + '/games/' + gameID + '/pitching').then(({
                            json,
                            status,
                            headers
                        }) => successCallback(json, status, headers)).catch(errorCallback)
                    }
                },
                /*
                * PLAYERS/GAMES/PITCHING
                */
                BIOMECHANIC: {
                    // GET teams/players/games/pitches index
                    getIndex (teamID, playerID, gameID, successCallback, errorCallback) {
                        http('teams/' + teamID + '/players/' + playerID + '/games/' + gameID + '/pitching/biomechanic')
                            .then(({
                                json,
                                status,
                                headers
                            }) => successCallback(json, status, headers)).catch(errorCallback)
                    }
                }
            },
            /*
            * PLAYERS/REPORTS
            */
            REPORTS: {
                // GET teams/players/reports detail
                getDetail (teamID, playerID, reportID, successCallback, errorCallback) {
                    http('teams/' + teamID + '/players/' + playerID + '/reports/' + reportID).then(({
                        json,
                        status,
                        headers
                    }) => successCallback(json, status, headers)).catch(errorCallback)
                }
            }
        }
    },
    /****************************************************
     * GAMES
     ****************************************************/
    GAMES: {
        getVideo (videoId, successCallback, errorCallback) {
            return http('games/videos/' + videoId).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        getVideoList (query, successCallback, errorCallback) {
            return http('games/videos' + query).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        // GET games/ index
        async getIndex (query, successCallback, errorCallback) {
            return http('games/?' +  qs(query)).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        // GET games detail
        getDetail (gameID, successCallback, errorCallback) {
            http('games/' + gameID).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        /*
         * ROSTERS
         */
        ROSTERS: {
            // GET games/rosters index
            getIndex (query, successCallback, errorCallback) {
                let url = setting.apiURL + 'games/rosters/'
                let options = {}
                if ('team_id' in query) {
                    options['team_id'] = query.team_id
                }
                if ('player_id' in query) {
                    options['player_id'] = query.player_id
                }
                if ('date-after' in query) {
                    options['date-after'] = query['date-after']
                }
                if ('date-before' in query) {
                    options['date-before'] = query['date-before']
                }
                if ('pitching' in query) {
                    options['pitching'] = query.pitching
                }
                if ('pitchingreportstatus' in query) {
                    options['pitchingreportstatus'] = query.pitchingreportstatus
                }
                if ('limit' in query) {
                    options['limit'] = query.limit
                }

                http('games/rosters/?' + qs(options)).then(({
                    json,
                    status,
                    headers
                }) => successCallback(json, status, headers)).catch(errorCallback)
            },
            // GET games/rosters detail
            getDetail (options, successCallback, errorCallback) {
                // console.log('GAMES ROSTERS getDetail', options)
                http('games/rosters/?' + qs(options)).then(({
                    json,
                    status,
                    headers
                }) => successCallback(json, status, headers)).catch(errorCallback)
            },
            SUMMARY: {
                // GET games/rosters/summary index
                getIndex (query, successCallback, errorCallback, async = true) {
                    // let url = setting.apiURL + 'games/rosters/summary'
                    let options = {}
                    if ('team_id' in query) {
                        options['team_id'] = query.team_id
                    }
                    if ('pitching' in query) {
                        options['pitching'] = query.pitching
                    }
                    if ('batting' in query) {
                        options['batting'] = query.batting
                    }
                    if ('level' in query) {
                        options['level'] = query.level
                    }
                    if ('afterDate' in query) {
                        options['date-after'] = query.afterDate
                    }
                    if ('beforeDate' in query) {
                        options['date-before'] = query.beforeDate
                    }
                    if ('date-after' in query) {
                        options['date-after'] = query['date-after']
                    }
                    if ('date-before' in query) {
                        options['date-before'] = query['date-before']
                    }
                    if ('league' in query) {
                        options['league'] = query.league
                    }
                    return http('games/rosters/summary?' + qs(options)).then(({
                        json,
                        status,
                        headers
                    }) => successCallback(json, status, headers)).catch(errorCallback)
                },
                getSummary (query, successCallback, errorCallback) {
                    return http('games/rosters/summary' + query).then(({
                        json,
                        status,
                        headers
                    }) => successCallback(json, status, headers)).catch(errorCallback)
                }
            }
        }
    },
    /****************************************************
     * PITCHES（投球データAPI）
     ****************************************************/
    PITCHES: {
        async getIndexAsync(query) {
            let options = query
            if ('point' in query) {
                options.point = {}
                options.point['spread-over'] = query.point
                options.point['spread-under'] = query.point
            }
            try {
                const { json, status, headers } = await http('pitches/?' + qs(options))
                return { json, status, headers }
            } catch (error) {
                throw error
            }
        },
        getDetail (pitchID, successCallback, errorCallback) {
            http('pitches/' + pitchID).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        // GET pitches/ index
        getIndex (query, successCallback, errorCallback, async = false) {
            let options = query
            if ('point' in query) {
                options.point = {}
                options.point['spread-over'] = query.point
                options.point['spread-under'] = query.point
            }
            return http('pitches/?' + qs(options)).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        getVideo (pitchID, successCallback, errorCallback, is3D, isBatter) {
            const options = {}
            if (isBatter) {
                options.batter = true
            }
            if (is3D) {
                options['3d'] = true
            }

            return http('pitches/' + pitchID + '/video?' + qs(options)).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        /*
         * SUMMARY
         */
        SUMMARY: {
            // GET pitches/summary detail
            getDetail (level, successCallback, errorCallback) {
                http('pitches/summary').then(({
                    json,
                    status,
                    headers
                }) => successCallback(json, status, headers)).catch(errorCallback)
            }
        },
        /*
         * ANALYSIS
         */
        ANALYSIS: {
            // GET pitches/analysis detail
            getDetail (pitcherID, pitcherTeam, options, successCallback, errorCallback, async = true) {
                // console.log('ANALYSIS getDetail', pitcherID, pitcherTeam, options)
                if (pitcherID !== '' && pitcherTeam !== '') {
                    options['pitcher'] = pitcherID + '@' + pitcherTeam
                }
                let url = 'pitches/analysis/?'+qs(options)
                http(url).then(({
                    json,
                    status,
                    headers
                }) => successCallback(json, status, headers)).catch(errorCallback)
            }
        },
        /*
         * MATCHUP
         */
        MATCHUP: {
            // GET pitches/matchup index
            getIndex (query, successCallback, errorCallback) {
                // console.log('MATCHUP getIndex', pitcherID, pitcherTeam, options)
                let url = setting.apiURL + 'pitches/matchup/'
                let options = {}
                if ('date-after' in query) {
                    options['date-after'] = query['date-after']
                }
                if ('date-before' in query) {
                    options['date-before'] = query['date-before']
                }
                if ('date' in query) {
                    options['date'] = query.date
                }
                if ('pitcherteam' in query) {
                    if ('pitcher' in query) {
                        options['pitcher'] = query.pitcher + '@' + query.pitcherteam
                    } else {
                        options['pitcherteam'] = query.pitcherteam
                    }
                }
                if ('batterteam' in query) {
                    if ('batter' in query) {
                        options['batter'] = query.batter + '@' + query.batterteam
                    } else {
                        options['batterteam'] = query.batterteam
                    }
                }
                if ('game_id' in query) {
                    options['game_id'] = query.game_id
                }
                if ('level' in query) {
                    options['level'] = query.level
                }
                if ('league' in query) {
                    options['league'] = query.league
                }
                if ('limit' in query) {
                    options['limit'] = query.limit
                }
                if ('pitchingdata' in query) {
                    options['pitchingdata'] = query.pitchingdata
                }
                if ('umpire_code' in query) {
                    options['umpire_code'] = query['umpire_code']
                }
                return http('pitches/matchup/?' + qs(options)).then(({
                    json,
                    status,
                    headers
                }) => successCallback(json, status, headers)).catch(errorCallback)
            }
        }
    },
    /****************************************************
     * MATCHUP（対戦データAPI）
     ****************************************************/
    MATCHUP: {
        // GET matchup profile
        getProfile (playerID, teamID, role, filters, successCallback, errorCallback) {
            const options = {
                player_id: playerID+'@'+teamID,
                player_type: role
            }
            Object.assign(options, filters)
            return http('matchup/profile/?' + qs(options)).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        // GET matchup list
        getList (playerID, teamID, role, filter ,successCallback, errorCallback) {
            const options = {}
            options[role] = playerID+'@'+teamID
            Object.assign(options, filter)
            return http('matchup/list/?' + qs(options)).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        // GET matchup detail (modal payload)
        getMatchupDetail (id, successCallback, errorCallback) {
            const options = {
                id
            }
            return http('matchup/detail/?' + qs(options)).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        }
    },
    /****************************************************
     * DEVICES（リアルタイム用端末管理API）
     ****************************************************/
    DEVICES: {
        // GET devices index
        getIndex (successCallback, errorCallback) {
            http('device/').then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        // GET apitches detail
        getDetail (id, successCallback, errorCallback) {
            // let url = setting.apiURL + 'apitches/?date-after=' + date
            http('device/' + id).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        // POST apitches detail（分析参照用データの登録用にのみ使用）
        postDetail (id, obj, successCallback, errorCallback) {
            http('devices/' + id + '/apitches').then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        }
    },
    /****************************************************
     * APITCHES（リアルタイム用）
     ****************************************************/
    APITCHES: {
        // GET apitches index
        getIndex (afterDate, beforeDate, sensorDeviceID, successCallback, errorCallback) {
            // 日時はUTCで指定する
            const options = {
                'timestamp-after': afterDate,
                'timestamp-before': beforeDate,
                limit: 1000
            }
            let url = 'apitches/?' + qs(options)
            http(url).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        // GET apitches detail
        getDetail (id, successCallback, errorCallback) {
            // let url = setting.apiURL + 'apitches/?date-after=' + date
            let url = 'apitches/' + id
            http(url).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        // PUT apitches detail
        putDetail (id, option, successCallback, errorCallback) {
            // console.log('putDetail', id, option)
            // let url = setting.apiURL + 'apitches/?date-after=' + date
            let url = 'apitches/' + id
            let obj = {
                'additional': option
            }
            http(url, {}, 'PUT', JSON.stringify(obj)).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        putDetails (objs, successCallback, errorCallback) {
            // console.log('putDetail', id, option)
            // let url = setting.apiURL + 'apitches/?date-after=' + date
            Promise.all(objs.map(d => {
                return http('apitches/' + d.id, {}, 'PUT', JSON.stringify({
                    'additional': d.additional
                }))
            })).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        // DELETE apitches detail
        deleteDetail (id, successCallback, errorCallback) {
            // console.log('putDetail', id, option)
            // let url = setting.apiURL + 'apitches/?date-after=' + date
            http('apitches/' + id, {}, 'DELETE').then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        }
    },
    /*
     * PLAYERS
     */
    PLAYERS: {
        // GET players index
        getIndex (successCallback, errorCallback) {
            http('/players/').then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        /*
         * SUMMARIES
         */
        SUMMARIES: {
            // GET players/summaries/searches index
            getIndex (options, successCallback, errorCallback) {
                http('players/summaries/searches/?' + qs(options)).then(({
                    json,
                    status,
                    headers
                }) => successCallback(json, status, headers)).catch(errorCallback)
            },
            /*
             * PATTERNS
             */
            PATTERNS: {
                // GET players/summaries/searches/patterns index
                getIndex (successCallback, errorCallback) {
                    // console.log('MATCHUP getIndex', pitcherID, pitcherTeam, options)
                    http('players/summaries/searches/patterns/').then(({
                        json,
                        status,
                        headers
                    }) => successCallback(json, status, headers)).catch(errorCallback)
                },
                // GET players/summaries/searches/patterns detail
                getDetail (patternId, successCallback, errorCallback) {
                    // console.log('MATCHUP getIndex', pitcherID, pitcherTeam, options)
                    http('players/summaries/searches/patterns/' + patternId + '/result').then(({
                        json,
                        status,
                        headers
                    }) => successCallback(json, status, headers)).catch(errorCallback)
                }
            }
        }
    },
    /****************************************************
     * UMPIRES（審判データAPI）
     ****************************************************/
    UMPIRES: {
        // 審判一覧
        getIndex (query, successCallback, errorCallback) {
            let options = {}
            if ('year' in query) {
                options['year'] = query['year']
            }
            http('umpires/?' + qs(options)).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        // 審判の出場試合
        getGames (options, successCallback, errorCallback) {
            http('umpires/games?' + qs(options)).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        }
    },
    /****************************************************
     * SABR（セイバーデータ）
     ****************************************************/
    SABR: {
        // GET players index
        getTeams (query, successCallback, errorCallback) {
            http('BIP/teams/').then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        },
        getPlayers (query, successCallback, errorCallback) {
            let options = {}
            if ('umpire_code' in query) {
                options['umpire_code'] = query['umpire_code']
            }
            if ('position' in query) {
                options['position'] = query['position']
            }
            http('BIP/players/?' + qs(options)).then(({
                json,
                status,
                headers
            }) => successCallback(json, status, headers)).catch(errorCallback)
        }
    },
    /*
     * TOKENS
     */
    TOKENS: {
        // PATCH tokens
        patchTokens (successCallback, errorCallback) {
            http('tokens/', {}, 'PATCH').then(({json}) => {
                let userAccount = ls.get('userAccount')
                userAccount.token_expire = json.expire
                ls.set('userAccount', userAccount)
                successCallback(json)
            }).catch(errorCallback)
        }
    }
}
